export default {
  'theme-stress-text': '#000000',
  'theme-text': '#252b3a',
  'theme-aide-text': '#3b3e55',
  'theme-placeholder': '#9c9db4',
  'theme-disable-text': '#BCBCD0',
  'theme-light-text': '#ffffff',
  'theme-icon-fill': '#000000',
  'theme-icon-fill-weak': '#3b3e55',
  'theme-icon-fill-hover': '#9c9db4',
  'theme-icon-placeholder': '#bcbcd0',
  'theme-icon-bg': '#FFFFFF',
  'theme-brand-text': '#DA203E',
  'theme-shape-icon-fill': '#BCBCD0',
  'theme-shape-icon-fill-hover': '#BCBCD0',
  'theme-shape-icon-fill-disabled': '#BCBCD0',
  'theme-icon-bg-other': '#FFFFFF',
  'theme-brand': '#DA203E',
  'theme-ui-brand': '#165dff',
  'theme-dividing-line': '#F1F1F8',
  'theme-line-split': '#E3E3EE',
  'theme-line-border': '#e3e3ee',
  'theme-line-border-light': '#F3F4F6',
  'theme-disabled-line': '#F1F1F8',
  'theme-form-control-line-hover': '#e3e3ee',
  'theme-form-control-line-active': '#2951E0',
  'theme-form-control-line-active-checkbox': '#DBE2FA',
  'theme-btn-primary': '#000000',
  'theme-btn-primary-hover': '#333333',
  'theme-btn-primary-active': '#000000',
  'theme-btn-primary-disabled': '#cccccc',
  'theme-btn-default': '#FFFFFF',
  'theme-btn-default-hover': '#F8F8FA',
  'theme-btn-default-disabled': '#F1F1F8',
  'theme-btn-default-border': '#E3E3EE',
  'theme-btn-default-border-hover': '#d1d1e0',
  'theme-btn-default-border-disabled': '#F1F1F8',
  'theme-table-header-bg': '#F9F9FB',
  'theme-table-body-bg-hover': '#F9F9FB',
  'theme-link': '#2951E0',
  'theme-link-light': '#94A8F0',
  'theme-link-disabled': '#B8C5F5',
  'theme-icon-hover': '#F1F1F8',
  'theme-icon-active': '#F1F1F8',
  'theme-num-bg': '#F1F1F8',
  'theme-default-bg': '#FFFFFF',
  'theme-global-bg': '#F9F9FB',
  'theme-bg-hover': '#F1F1F8',
  'theme-card-bg': '#FFFFFF',
  'theme-overlay-bg': '#FFFFFF',
  'theme-overlay-hover-bg': '#F9F9FB',
  'theme-disabled-bg': '#F9F9FB',
  'theme-feedback-overlay-bg': '#3F425A',
  'theme-badge-bg': '#e3e3ee',
  'theme-danger-bg': '#F9DADF',
  'theme-danger': '#DA203E',
  'theme-danger-line': '#f66f6a',
  'theme-danger-text': '#DA203E',
  'theme-contrast-hover': '#831325',
  'theme-contrast-active': '#831325',
  'theme-warning-bg': '#FCE4DA',
  'theme-warning': '#ED5F22',
  'theme-warning-line': '#fa9841',
  'theme-warning-text': '#F07A47',
  'theme-success-bg': '#D6ECE2',
  'theme-success-line': '#50d4ab',
  'theme-success': '#088F4E',
  'theme-success-text': '#31A26C',
  'theme-checkbox-border-color': '#D1D1E0',
  'theme-second-button-hover-border-color': '#D1D1E0',
  'theme-tag-border-blue-color': '#B8C5F5',
  'theme-tag-bg-blue-color': '#DBE2FA',
  'theme-tag-text-blue-color': '#2951E0',
  'theme-shadow-1':
    ' 0px 8px 24px 0px rgba(29, 31, 58, 0.04), 0px 4px 12px 0px rgba(29, 31, 58, 0.02), 0px 2px 6px 0px rgba(29, 31, 58, 0.02), 0px 1px 3px 0px rgba(29, 31, 58, 0.02);',
  'theme-shadow-2':
    '0px 8px 24px 0px rgba(29, 31, 58, 0.06), 0px 4px 12px 0px rgba(29, 31, 58, 0.06), 0px 2px 6px 0px rgba(29, 31, 58, 0.06), 0px 1px 3px 0px rgba(29, 31, 58, 0.06);',
  'theme-shadow-3':
    '0px 16px 48px 0px rgba(29, 31, 58, 0.12), 0px 8px 24px 0px rgba(29, 31, 58, 0.06), 0px 4px 12px 0px rgba(29, 31, 58, 0.06), 0px 2px 6px 0px rgba(29, 31, 58, 0.06), 0px 1px 3px 0px rgba(29, 31, 58, 0.06);',
  'theme-list-item-active-text': '#252b3a',
  'theme-list-item-hover-text': '#3b3e55',
  'theme-icon-disabled-color': '#BCBCD0',
  'theme-brand-foil': '#DA203E',
  'theme-list-item-selected-bg': '#F1F1F8',
  'theme-contrast': '#DA203E',
  'theme-shadow': 'rgba(37, 43, 58, 0.24)',
  'theme-primary': '#000000',
  'theme-aihub-build-gradio': '#ED5F22',
  'theme-fullscreen-overlay-bg': '#FFFFFF',
  'theme-block': '#FFFFFF',
  'theme-menu-item': '#252b3a',
  'theme-menu-item-hover': '#0f0f0f',
  'theme-echarts-series-item-color1': '#2951E0',
  'theme-echarts-series-item-color2': '#32C5FF',
  'theme-echarts-series-item-color3': '#0091FF',
  'theme-echarts-series-item-color4': '#6236FF',
  'theme-echarts-series-item-color5': '#0CB8C6',
  'theme-echarts-series-item-color6': '#F57315',
  'theme-echarts-series-item-color7': '#E1597E',
  'theme-echarts-series-item-color8': '#4F762A',
  'theme-echarts-series-item-color9': '#555555',
  'theme-echarts-series-item-color10': '#694C1F',
  'theme-color-border': '#3D444D',
  'theme-echarts-calendar-item-color1': '#F9F9FB',
  'theme-echarts-calendar-item-color2': '#ADDAC4',
  'theme-echarts-calendar-item-color3': '#5AB489',
  'theme-echarts-calendar-item-color4': '#088F4E',
  'theme-echarts-calendar-item-color5': '#066437',
  'theme-download-btn-bg': '#FFFFFF',
  'theme-download-btn-border-color': '#D1D1E0',
  'theme-download-btn-text-color': '#252B3A',
  'theme-download-btn-hover-bg': '#F8F8F8',
  'theme-download-btn-hover-border': '#D1D1E0',
  'theme-default-ui-bg': '#FFFFFF',
  'theme-area': '#F1F1F8',
  'theme-login-default-bg': '#F9F9FB',
  'theme-tab-mask-left': 'linear-gradient(90deg, rgb(249, 249, 251) 26px, rgba(249, 249, 251, 0))',
  'theme-tab-mask-right': 'linear-gradient(90deg, rgba(249, 249, 251, 0), rgb(249, 249, 251) 56px)',
  'theme-card-mask-bottom': 'linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))',
  'theme-info-bg': '#e9edfa',
  'theme-info': '#5e7ce0',
  'theme-info-line': '#5e7ce0',
  'theme-line': '#E3E3EE',
  'theme-text-selection-bg': '#d7d4f0',
  'theme-range-item-hover-bg': '#e9edfa',
  'theme-label-bg': '#e9edfa',
  'theme-step-bg': '#DBE2FA',
  'theme-select-bg': '#F1F1F8',
  'theme-release-card-border-color': '#e5e4e4',
  'theme-release-card-bg-color': '#f5f7f9',
  'theme-release-card-text-color': '#606060',
  'theme-state-open-bg': '#D6ECE2',
  'theme-state-finish-bg': '#ECDBF9',
  'theme-code-line-bg': '#f3b5bf',
  'theme-code-del-change-bg': '#ffebe9',
  'theme-code-ins-change-bg': '#DAFBE1',
  'theme-code-change-text': '#24292e',
  'theme-code-del-change-detail-bg': '#FFAAAA',
  'theme-code-ins-change-detail-bg': '#aceebb',
  'theme-code-expand-action-bg': '#f8fafd',
  'theme-code-expand-bg': '#f8fafd',
  'theme-code-expand-text': '#9c9db4',
  'theme-code-expand-hover-bg': '#bfcbf3',
  'theme-home-step-bg': '#D1D2D4',
  'theme-home-step-active-bg': '#2D2D2E',
  'theme-md-blockquote-border-color': '#E3E3EE',
  'theme-md-blockquote-bg': '#F1F1F8',
  'theme-collapse-rule-bg': 'linear-gradient(270deg, #FFFFFF 0%, #E3E3EE 100%)',
  'theme-rule-card-bg': 'linear-gradient(95.73deg, #fafbff 2.22%, #e7e8ef 94.01%)',
  'theme-edit-border-color': 'transparent',
  'theme-growth-lv1-bg': 'linear-gradient(96.07deg, #b5bdcf 0%, #d5d9e4 100%)',
  'theme-growth-lv2-bg': 'linear-gradient(276.07deg, #c0d5ff 0%, #c6c0ec 100%)',
  'theme-growth-lv3-bg': 'linear-gradient(96.07deg, #ebb693 0%, #eddbde 100%)',
  'theme-vote-bg': 'linear-gradient(146deg, #e2eaff 0%, #fdf4f6 35%, #fef9fa 66%, #ebf2ff 100%)',
  'theme-preference-setting-bg': '#F8F8FA',
  'theme-home-tools-bg': '#FFFFFF',
  'theme-skeleton': '#f2f2f3',
  'theme-md-code-bg': '#F1F1F8',
  'theme-mirrors-warning-msg-bg': '#fbefd8',
  'theme-code-checked-bg': '#fff8c5',
  'theme-resolve-code-left-bg': 'rgba(132, 199, 167, 0.5)',
  'theme-resolve-code-right-bg': 'rgba(192, 189, 245, 0.5)',
  'theme-resolve-code-checked-bg': '#B8C5F5',
  'theme-resolve-code-origin-checked-bg': '#ADDAC4',
  'theme-home-tab-color': '#0F0F0F',
  'theme-home-tab-hover-color': '#F1F1F1',
  'theme-home-tab-hover-bg-color': '#E5E5E5',
  'theme-home-tab-bg-color': '#F2F2F2',
  'theme-menu-text': '#0F0F0F',
  'theme-menu-icon-fill': '#0F0F0F',
  'theme-menu-hover-bg': '#f2f2f2',
  'theme-home-card-bg': 'linear-gradient(270deg, #FFFFFF 0%, #F9FAFB 100%)',
  'theme-home-card-shadow': '0px 4px 4px 0px rgba(245, 245, 245, 0.50)',
  'theme-home-card-border': '#F3F4F6',
  'theme-home-card-color': '#000000',
  'theme-home-card-color-placeholder': '#606060',
  'theme-home-card-star-border': '#F3F4F6',
  'theme-home-btn-bg': '#F2F2F2',
  'theme-home-btn-hover': '#E5E5E5',
  'theme-home-btn-active': '#E5E5E5',
  'theme-home-btn-color': '#0F0F0F',
  'theme-task-center-modal':
    'linear-gradient(180deg, rgba(218, 32, 62, 0.1) -15.79%, rgba(255, 255, 255, 0.12) 50.73%, #ffffff 100%)',
  'theme-tab-left-linear': 'linear-gradient(90deg, rgba(255, 255, 255, 1) 26px, rgba(255, 255, 255, 0))',
  'theme-tab-right-linear': 'linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 56px)',
  'theme-chat-aslide-text': '#0D0D0D',
  'theme-chat-aslide-select-bg': '#E3E3E3',
  'theme-chat-aslide-time-title': '#000000',
  'theme-chat-aslide-select-bg-hover': '#E3E3E3',
  'theme-chat-aslide-delete-bg-hover': '#e3e3e3',
  'theme-chat-aslide-delete-icon-hover': '#f3f4f6',
  'theme-chat-aslide-inset-mask': '#d7d7d7',
  'theme-chat-aslide-icon-bg': '#ededed',
  'theme-chat-aslide-model-hover-bg': '#f9f9fb',
  'theme-chat-aslide-model-item-hover-bg': '#f4f7f9',
  'theme-chat-aslide-model-title': '#5d5d5d',
  'theme-chat-consult-input': '#DBE2FA29',
  'theme-chat-consult-border-color': '#4D6BFE3D',
  'theme-chat-consult-bg-color': '#4D6BFE0A',
  'theme-chat-consult-text-color': '#4D6BFE',
  'theme-chat-bg': '#FFFFFF',
  'theme-chat-submit-btn': '#d7d7d7',
  'theme-chat-action-bg': '#ffffff',
  'theme-chat-action-text': '#3b3e55',
  'theme-chat-action-border-color': '#e3e3ee',
  'theme-chat-action-active-bg': '#dbe2fa',
  'theme-chat-action-active-border': '#2951e080',
  'theme-chat-project-text': '#3B3E55',
  'theme-chat-aside-bg': '#f9f9f9',
  'theme-chat-aslide-current-delete-bg': '#f9f9f9 ',
  'theme-chat-aslide-agent-title': '#000000',
  'theme-chat-aslide-guide-title': '#252B3A',
  'theme-chat-aslide-guide-desc': '#3B3E55',
  'theme-chat-aslide-guide-desc-bg': '#F2F2F2',
  'theme-chat-aslide-guide-desc-bg-hover': '#E5E5E5',
  'theme-star-hover-bg': 'linear-gradient(180deg, #FFFFFF 4.17%, #FEF4E3 100%);',
  'theme-model-card-bg': 'linear-gradient(0deg, rgba(0, 67, 255, 0.05), rgba(0, 67, 255, 0.05))',
  'theme-brand-tag-text': '#FF6F42',
  'theme-brand-tag-bg': '#FFAE001F',
  'theme-point-text': '#6F1A00',
  'theme-im-n-bg': '#DBE2FA'
};
